import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import { motion } from 'framer-motion';
const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'your_service_id',
      'your_template_id',
      form.current,
      'your_user_id_or_public_key'
    ).then(
      (result) => {
        alert('Message sent successfully!');
        form.current.reset();
      },
      (error) => {
        alert('Failed to send message.');
        console.error(error);
      }
    );
  };

  return (
    <div name="contact" className="max-w-2xl mx-auto my-10">
      <motion.h2 initial={{ opacity: 0, y:50}} whileInView = {{opacity: 1, y:0}} transition={{duration: 1, ease: "easeOut"}} className="text-4xl text-blue-950 text-center m-6 font-semibold font-poppins cursor-default">Contact Us</motion.h2>
    <motion.form initial={{ opacity: 0, y: 50}}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }} ref={form} onSubmit={sendEmail} className="w-full mx-auto px-8 md:p-4 bg-white rounded shadow">
      <input type="text" name="name" placeholder="Your Name" required className="p-2 mb-2 w-full border-2 rounded placeholder-gray-600 border-gray-800" />
      <input type="email" name="email" placeholder="Your Email" required className="p-2 mb-2 w-full border-2 rounded placeholder-gray-600 border-gray-800" />
      <textarea name="message" placeholder="Your Message" required className="p-2 mb-2 w-full border-2 rounded placeholder-gray-600 border-gray-800" />
      <button type="submit" className="w-full text-lg bg-green-600 text-white py-2 rounded hover:bg-green-800">
        Send Email
      </button>
    </motion.form>
    </div>
  );
};

export default Contact;
